import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from "react-router-dom";

import config from "@/config";
import useCache from "@/hooks/useCache";
import useStateHandler from "@/hooks/useStateHandler";
import Loader from "@/shared-components/loader/Loader"; // ✅ Updated import

export default function SuarteWorld() {
  const { loading, fetchData } = useCache("suarteworld", `${config.apis.api.url}/suarteworld?seed=${parseInt(Math.random() * 1000000)}`, { expiresIn: ["0", "seconds"] });
  const { cacheHandler } = useStateHandler();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      cacheHandler.storeInCache("artworks_of_suarteworld", { ...fetchData, endpoint: `/suarteworld?seed=${parseInt(Math.random() * 1000000)}` }, {
        invalidateWhen: ["EDIT_ARTWORK", "DELETE_ARTWORK"]
      });

      navigate(`/suarteworld/artwork/${fetchData.data[0]._id}`, {
        state: {
          cacheKey: "artworks_of_suarteworld",
          from: location.state?.from
        },
        replace: true
      });
    }
  }, [loading]);

  return (
    <>
      <Helmet>
        <title>
          Suarteworld | Scroll and interact with exclusive global art
        </title>
        <meta
          name="description"
          content="Get immersed in the art world. Scroll and interact with paintings and wall sculptures and find your next masterpiece. Join the conversation with likes, thoughts, ratings, and more."
        />
      </Helmet>
      {loading && <Loader />} {/* ✅ Use the generic loader */}
    </>
  );
}
